import { render, staticRenderFns } from "./UserInitials.vue?vue&type=template&id=3c02ad38&scoped=true"
import script from "./UserInitials.vue?vue&type=script&lang=js"
export * from "./UserInitials.vue?vue&type=script&lang=js"
import style0 from "./UserInitials.vue?vue&type=style&index=0&id=3c02ad38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c02ad38",
  null
  
)

export default component.exports